export default __webpack_public_path__ + "static/media/slide16.c4d5fe9e.jpg";